import styled, { css } from 'styled-components';
import { ITheme } from '../../styles/theme';


export const TotalPriceContainer = styled.div`
	display: flex;
	justify-content: center;
	
	margin: 20px auto;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		margin: 5px auto;
		max-width: 99%;
		display: none;
	};
`;

export const TotalPrice = styled.div`
	display: flex;
	justify-content: space-between;
	
	padding: 8px 13px;
		
	width: 230px;
	border: 0.5px solid #444449;
	border-right: unset;
	
	span {
		font-weight: 700;
	}
`;

export const MenuNavigationItem = styled.div<{isActive:boolean}>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	svg {
		margin-bottom: 5px;
	}
	
	${({ isActive, theme }: { isActive:boolean, theme: any }) => isActive && css`
		color: ${theme.colors.fallow};
				
		svg {
			color: ${theme.colors.fallow};
		}
	`}

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		width: 100%;
	};
`;

export const FooterMenuNavigationSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: baseline;

	height: 100%;
	min-height: 100%;

	& .anticon {
		cursor: pointer;
	};
`;

export const FooterMenuNavigation = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: top;

  border-top: 0.5px solid rgba(68, 68, 73, 0.5);
  
  font-size: 12px;
  
	padding: 10px 0px 0px 0px;

	user-select: none;

	& > ${FooterMenuNavigationSection} {
		width: 100%;
	}
	
	@media (min-width: ${(props) => props.theme.mediaQueryConstants.phone + 1}px) {
  	position: absolute;
		right: 400px;
		bottom: 0px;

		min-height: 80px;
		height: 12.5%;
		max-height: 122px;

		width: calc(100% - 400px);

		justify-content: center;

		border: none;

		& > ${FooterMenuNavigationSection} > div {
			padding: 0px 10px;
		};

		& > ${FooterMenuNavigationSection}:nth-of-type(3) > ${MenuNavigationItem} {
			padding-top: 6px;
			font-size: 23px;
		};
	
		& > ${FooterMenuNavigationSection}:nth-of-type(3) > ${MenuNavigationItem} > div {
			font-size: 12px;
		};
	}

	@media (min-width: ${(props) => props.theme.mediaQueryConstants.desktopSmall + 1}px) {
		& > ${FooterMenuNavigationSection} > div {
			padding: 0px 20px;
		};
	}
`;

export const HeaderContainerSegment = styled.div`
	width: 100%;
`;

export const HeaderContainer = styled.div`
	width: 100%;

	display: flex;
	justify-content: space-around;
	align-items: flex-end;

	border-bottom: 0.5px solid rgba(68, 68, 73, 0.5);

	height: ${({theme}:{theme:ITheme}) => theme.footerHeight}px;

	vertical-align: bottom;

	z-index: 13;

	& > ${HeaderContainerSegment}:nth-of-type(1) {
		padding: 3px 12px;
		font-size: 18px;
		font-weight: 700;
	};

	& > ${HeaderContainerSegment}:nth-of-type(2) {
		width: 1px;
		min-width: 1px;
	};

	& > ${HeaderContainerSegment}:nth-of-type(3) {
		text-align: right;
	};

`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	max-height: 100%;
	
	overflow: auto;

	pointer-events: auto;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		height: 100%;
		max-height: ${({theme}:{theme:ITheme}) => `calc(100% - ${theme.footerHeight}px)`};
	};

	@media (max-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {
		display: block;
	};
`;

export const TotalPriceContainerMobile = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	user-select: none;

	height: ${({theme}:{theme:ITheme}) => theme.footerHeight}px;
	bottom: ${({theme}:{theme:ITheme}) => theme.footerHeight}px;
	
	position: absolute;
	width: 100%;

	z-index: 13;

	pointer-events: none;

		& > div {
			width: 100%;
			text-align: center;
			font-size: 20px;
		}

		& .anticon {
			pointer-events: auto;
		}

		& > div:nth-of-type(1) {
			font-size: 18px;
			font-weight: 700;
		}

		& > div:nth-of-type(4) .anticon {
			padding: 5px 10px;
			background-color: ${({theme}:{theme:ITheme}) => theme.colors.fallow};
			border: 0.5px solid rgba(68, 68, 73, 0.2);
			color: white;
		}
`;

export const FooterContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	justify-content: space-between;

	height: 12.5%;
	min-height: 80px;

	background-color: white;

	z-index: 13;
	
	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		height: ${({theme}:{theme:ITheme}) => theme.footerHeight}px;
		min-height: unset;
		
		position: absolute;
    bottom: 0;
		width: 100%;

		border-top: 0.5px solid rgba(68, 68, 73, 0.5);

		padding-bottom: 10px;
  }
`;

export const Main = styled.div<{show:boolean, deviceInfo:{windowHeight:number}}>`
	display: block;

	min-height: 1px;
	max-height: 100%;

	max-width: 100%;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		${(props) => !props.show && css`
			display: none;
		`};

		bottom: ${({theme}:{theme:ITheme}) => theme.footerHeight}px;
		position: absolute;
		
		height: 60%;
		width: 100%;
		
		background-color: transparent;
		
		pointer-events: none;
	};
`;

export const MenuContainer = styled.div`
	width: 400px;
	height: 100%;
	
	background-color: white;
	
	box-sizing: content-box;
	
	display: flex;
	flex-direction: column;
	justify-content: inherit;

	user-select: none;
  
	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		height: auto;
		width: auto;
		max-width: 100%;
		border: unset;
		z-index: 12;
	}
`;

export const ControlItem = styled.div`
	width: 41px;
	height: 41px;
	
	background-color: ${({ theme }: { theme:ITheme }) => theme.colors.fallow};

	margin-left: 10px;
	cursor: pointer;
	
	display: flex;
	justify-content: center;
	align-items: center;
`;